import React, { useRef } from 'react';
import { Card, Col, Container, FormGroup, Row } from 'react-bootstrap';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import CustomDatePicker from '../../../Components/Utility/DatePicker/DatePicker';
import { usePOTemplateOrderState } from './AddPOTemplateProvider';
import ImgDropzone from '../../../Components/ImgDropzone/ImgDropzone';
import noImage from '../../../assets/images/no-image.png';
import { imageUrl } from '../../../Components/helper';

function POTopBar({ fromForm }) {
  const { poTemplateState, setPOTemplateState, onChangeForData, userInfo } = usePOTemplateOrderState();
  const childRef = useRef();
  const { t } = useTranslation('common');

  const getImageUrl = () => {
    const originalImg = poTemplateState?.poDetails?.originalImg;
    const image = poTemplateState?.poDetails?.image;

    if (originalImg) {
      if (originalImg.includes('base64') || originalImg.startsWith('data:')) {
        return originalImg;
      }
      if (originalImg && originalImg.length > 1 && !originalImg.includes('http')) {
        return `${imageUrl}/${originalImg}`;
      }
      return originalImg;
    }

    if (image) {
      if (image.includes('base64') || image.startsWith('data:')) {
        return image;
      }
      if (image.length > 1 && !image.includes('http')) {
        return `${imageUrl}/${image}`;
      }
      return image;
    }

    return '';
  };

  const handleImageUpload = async (type) => {
    try {
      const result = await childRef.current.showCroppedImg();

      if (!result || result === '') {
        if (type === 'close') {
          setPOTemplateState((oldEle) => ({
            ...oldEle,
            showUpload: false,
          }));
        }
        return;
      }

      const { imgRes, orgImage } = result;

      if (type === 'close') {
        setPOTemplateState((oldEle) => ({
          ...oldEle,
          showUpload: false,
        }));
        return;
      }

      if (isEmpty(imgRes)) {
        setPOTemplateState((oldEle) => ({
          ...oldEle,
          showUpload: false,
        }));
        return;
      }

      const imageResult = Array.isArray(imgRes) ? imgRes[0] : imgRes;
      const originalImageResult = Array.isArray(orgImage) ? orgImage[0] : orgImage;

      if (!imageResult || imageResult.includes('data:text/html')) {
        setPOTemplateState((oldEle) => ({
          ...oldEle,
          showUpload: false,
        }));
        return;
      }

      const rCol = { ...poTemplateState.poDetails };
      rCol.image = imageResult;
      rCol.originalImg = originalImageResult || imageResult;

      setPOTemplateState((oldEle) => ({
        ...oldEle,
        poDetails: rCol,
        showUpload: false,
      }));
    } catch (error) {
      setPOTemplateState((oldEle) => ({
        ...oldEle,
        showUpload: false,
      }));
    }
  };

  return (
    <Container fluid className="position-relative p-0">
      <Row>
        <Col lg={12}>
          <Card className="listing-card pt-1">
            <Card.Body>
              <Row>
                <Col lg={6} className="company-logo-block d-flex">
                  <figure>
                    <img
                      alt=""
                      src={
                        poTemplateState?.poDetails?.image === `images/${userInfo?.company}/logo.png` ||
                        poTemplateState?.poDetails?.image === `images/${userInfo?.companyURL}/logo.jpg`
                          ? noImage
                          : poTemplateState?.poDetails?.image || noImage
                      }
                    />
                  </figure>

                  <button
                    className="btn align-items-center justify-content-center"
                    title={t('ADD_PO_TEMPLATE_PROVIDER.UPLOAD')}
                    onClick={(e) => onChangeForData(e, 'uploadImage')}
                    disabled={!fromForm}
                    type="button"
                  >
                    <span className="icon-upload" />
                  </button>
                </Col>
                <Col lg={6}>
                  <div className="d-flex">
                    <div className="custom-switch-on-off po-template  ml-auto">
                      <BootstrapSwitchButton
                        onlabel={t('ADD_PO_TEMPLATE_PROVIDER.ACTIVE')}
                        offlabel={t('ADD_PO_TEMPLATE_PROVIDER.INACTIVES')}
                        onChange={(e) => onChangeForData(e, 'PO_Template_Button')}
                        checked={poTemplateState?.poDetails?.isActive}
                        disabled={!fromForm}
                      />
                    </div>
                  </div>
                  <Row>
                    <Col lg={12}>
                      <div className="input-group form-floating-label-po fixed-label">
                        <label className="asterisk-req f-14">{t('ADD_PO_TEMPLATE_PROVIDER.TEMPLATE_NAME')}</label>
                        <input
                          type="text"
                          name="Template Name"
                          placeholder={t('ADD_PO_TEMPLATE_PROVIDER.TEMPLATE_NAME')}
                          className="form-control f-14"
                          value={poTemplateState?.poDetails?.name}
                          onChange={(e) => onChangeForData(e, 'template_name')}
                          disabled={!fromForm}
                        />
                      </div>
                      {poTemplateState?.poDetails?.nameErr && !poTemplateState?.poDetails?.name && (
                        <span className="error-message">{t('ADD_PO_TEMPLATE_PROVIDER.TEMPLATE_NAME_REQUIRED')}</span>
                      )}
                    </Col>
                    <Col lg={6} className="mt-2">
                      <div className="input-group form-floating-label-po fixed-label">
                        <label className="asterisk-req f-14">{t('ADD_PO_TEMPLATE_PROVIDER.PERCHASE_ORDER')}</label>
                        <input type="text" placeholder={t('ADD_PO_TEMPLATE_PROVIDER.PERCHASE_ORDER')} className="form-control f-14" disabled readOnly />
                      </div>
                    </Col>
                    <Col lg={6} className="mt-2">
                      <FormGroup>
                        <label className="text-label mb-0 asterisk-req f-14">{t('ADD_PO_TEMPLATE_PROVIDER.PERCHASE_ORDER_DATE')}</label>
                        <div className="date">
                          <div className="input-button-container">
                            <CustomDatePicker
                              dateFormat="dd/MMM/yyyy"
                              name="selectedActualApproveByDate"
                              popperPlace="top-end"
                              placeholder={t('ADD_PO_TEMPLATE_PROVIDER.RECENT_DATE')}
                              disable
                              readOnly
                            />
                          </div>
                        </div>
                      </FormGroup>
                    </Col>
                    {poTemplateState?.showUpload && (
                      <ImgDropzone
                        ref={childRef}
                        onSubmit={handleImageUpload}
                        image={getImageUrl()}
                        acceptedFileExtenstion=".jpeg,.jpg,.png"
                        fromPOTemplate
                        title={t('ADD_PO_TEMPLATE_PROVIDER.PO_TEMPLATE')}
                        submitButtonName={t('ADD_PO_TEMPLATE_PROVIDER.UPLOAD_IMAGES')}
                      />
                    )}
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
export default POTopBar;
